

import React, { memo } from 'react';

import { ADDON_TYPE } from '@shootsta/common-domain-data';
import AddonView from '../../AddonView/AddonView';











const getCaptionText = (captionType) => `Caption (${captionType === 'BURN-IN' ? 'Burn-in' : captionType})`;

const getCaptionIconName = (captionType) => captionType === 'BURN-IN' ? 'burnin' : 'transcribe';

function CaptionAddonView({
  addon,
  addonType,
  isAddonDescriptionWrapped,
  getCaptions,
  onChangeAddonStatus,
  shouldShowActions = false,
  isNewDesign
}) {
  const getCaptionAddon = () =>
  addonType === ADDON_TYPE.BURN_IN_CAPTIONS ?
  getCaptions({ [addonType]: addon }) :
  getCaptions({ [addonType]: [addon] });


  const getViewItem = () => {
    const captionAddonList = getCaptionAddon();

    if (!captionAddonList.length) return null;

    const { captionValue: { label }, type } = captionAddonList[0];

    return {
      addonType,
      addonStatus: addon.status,
      iconName: getCaptionIconName(type),
      text: getCaptionText(type),
      subText: label,
      price: addon.cost,
      value: addon.value,
      suffixDagger: [ADDON_TYPE.BURN_IN_CAPTIONS, ADDON_TYPE.SRT_CAPTIONS].includes(addonType)
    };
  };

  const viewItem = getViewItem();

  return viewItem &&
  <AddonView
    isDescriptionWrapped={isAddonDescriptionWrapped}
    onChangeAddonStatus={onChangeAddonStatus}
    shouldShowActions={shouldShowActions}
    isNewDesign={isNewDesign}
    {...viewItem} />;


}

export default memo(CaptionAddonView);